import { Equal, HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';

export class ConcessionarioPessoaSearch {

    cdConcessionarioPessoa: number;
    stConcessionarioPessoa: number;
    cdConcessionario: number;
    cdConcessao: number;
    tpVinculo: number;
    cdPessoa: number;
    nmPessoa: string;
    limit: number;
    page: number;

    constructor(data?: {
        stConcessionarioPessoa?: number,
        cdConcessionarioPessoa?: number,
        cdConcessionario?: number,
        cdConcessao?: number,
        tpVinculo?: number,
        cdPessoa?: number,
        nmPessoa?: string,
        limit?: number
        page?: number
    }) {
        this.stConcessionarioPessoa = data && data.stConcessionarioPessoa;
        this.cdConcessionarioPessoa = data && data.cdConcessionarioPessoa;
        this.cdConcessionario = data && data.cdConcessionario;
        this.cdConcessao = data && data.cdConcessao;
        this.tpVinculo = data && data.tpVinculo;
        this.cdPessoa = data && data.cdPessoa;
        this.nmPessoa = data && data.nmPessoa;
        this.limit = data && data.limit;
        this.page = data && data.page;
    }

    getFilters(): IFilter {
        let filtros: IFilter = new HttpFilter([]);

        if (this.limit) {
            filtros.addFilter(new Equal('limit', this.limit));
        }

        if (this.cdConcessionarioPessoa) {
            filtros.addFilter(new Equal('cdConcessionarioPessoa', this.cdConcessionarioPessoa));
        }

        if (this.cdPessoa) {
            filtros.addFilter(new Equal('cdPessoa', this.cdPessoa));
        }

        if (this.cdConcessao) {
            filtros.addFilter(new Equal('cdConcessao', this.cdConcessao));
        }

        if (this.cdConcessionario) {
            filtros.addFilter(new Equal('cdConcessionario', this.cdConcessionario));
        }

        if (this.nmPessoa) {
            filtros.addFilter(new Equal('nmPessoa', this.nmPessoa));
        }

        if (this.tpVinculo != undefined) {
            filtros.addFilter(new Equal('tpVinculo', this.tpVinculo));
        }

        if (this.stConcessionarioPessoa != null) {
            filtros.addFilter(new Equal('stConcessionarioPessoa', this.stConcessionarioPessoa));
        }

        if (this.page) {
            filtros.addFilter(new Equal('page', this.page));
        }

        return filtros;
    }
}
